import React, { useEffect, useState } from "react";
import {
  Modal,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import {
  DragDropContext,
  Draggable,
  DraggingStyle,
  Droppable,
  DropResult,
  NotDraggingStyle
} from "@hello-pangea/dnd";

import settings from "../../assets/images/icons/console-6.svg";
import btnUsers from "../../assets/images/icons/whiteboard-menu-a-9.svg";
import widgetCard from "../../assets/images/tool/card.svg";
import boardSettings from "../../assets/images/icons/console-7.svg";

const UserSettings = (props: any) => {

  return (
    <React.Fragment>
      <UncontrolledDropdown className="top-tool-group settinsTool">
        <DropdownToggle tag="button" className="feature-anchor top-tool-btn" id="top-tool-setting-dropdown" data-tooltip-content="個人設定">
          <img src={settings} alt="" />
        </DropdownToggle>
        <DropdownMenu>
          <div className="top-tool-group">
            <div className="top-tool-items">
              <DropdownItem
                tag="a"
                href={`${process.env.REACT_APP_API_URL}/user/students`}
                target="_blank"
              >
                <img src={btnUsers} style={{ width: "30px" }} alt="" />
                <div>學員名單設定</div>
              </DropdownItem>
              <DropdownItem
                tag="a"
                href={`${process.env.REACT_APP_API_URL}/user/cards`}
                target="_blank"
              >
                <img src={widgetCard} style={{ width: "30px" }} alt="" />
                <div>翻卡內容設定</div>
              </DropdownItem>
              <DropdownItem
                tag="a"
                href={`${process.env.REACT_APP_API_URL}/user/settings`}
                target="_blank"
              >
                <img src={boardSettings} style={{ width: "30px" }} alt="" />
                <div>白板設定</div>
              </DropdownItem>
            </div>
          </div>
        </DropdownMenu>
      </UncontrolledDropdown>
      {/* <Modal id="layerModal" className={`h-100 w-100 items-center justify-center m-auto ${onReady? "layerReady" : ""}`} isOpen={showLayerModal} toggle={toggleLayerModal} modalClassName="zoomIn" zIndex={1000120} centered>
        <div className="w-100 mt-1 text-center"><label htmlFor="qr-code" className="crs-subtitle"> 圖層列表 </label></div>
        <div id="layerlist" className="list-content">
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable">
              {(provided, snapshot): JSX.Element => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  className="layerList"
                >
                  {sortedData.map((item: any, index: number) => (
                    <Draggable key={item.id} draggableId={item.id} index={index}>
                      {(provided, snapshot): JSX.Element => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          className={`layerItem ${snapshot.isDragging? "isDragging" : ""}`}
                        >
                          <div className="layerTitle" data-num={`${index + 1}`}>
                            {item.listTitle}
                          </div>
                          <div className="layerLock">

                          </div>
                          <div className="layerIcon" onClick={() => toggleDisplay(item)}>
                            {item.display? (
                              <img src={btnHideLayer} style={{ width: "20px" }} alt="" />
                            ) : (
                              <img src={btnShowLayer} style={{ width: "20px" }} alt="" />
                            )}
                          </div>
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
      </Modal> */}
    </React.Fragment>
  );
};

export default UserSettings;